var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"back-button z-20 fixed ml-0.5 top-[160px]"},[_c('a',{attrs:{"href":_vm.previousPage},on:{"click":_vm.handleClick}},[_c('OIcon',{attrs:{"icon":"back","svg-style":'width: 36px'}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }